'use client'

import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import AnimatedSection from '@/components/AnimatedSection'

const About: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    handleResize() // Set initial width
    window.addEventListener('resize', handleResize)
    
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Calculate smooth width based on window width (768px: 16.833rem, 1440px: 25.792rem)
  const calculateWidth = () => {
    const clampedWidth = Math.max(768, Math.min(1440, windowWidth))
    const ratio = (clampedWidth - 768) / (1440 - 768)
    return 16.833 + (25.792 - 16.833) * ratio
  }

  const blockWidth = calculateWidth()
  const statColumnWidthStyle =
    windowWidth >= 768 ? { width: `${blockWidth}rem` } : undefined
    
  return (
    <section className={styles.about}>
      <div className={styles.container}>
        {/* Block heading */}
        <div className={styles.heading}>
          <div className={styles.subtitle}>
            <p className={styles.subtitleText}>
              О компании
            </p>
          </div>
          <div className={styles.title}>
            <h2 className={styles.titleText}>
              true.code — надёжный<br />технологический партнёр
            </h2>
          </div>
        </div>
        
        {/* About content */}
        <div className={styles.content}>
          {/* Paragraph with button */}
          <div className={styles.textSection}>
            <div className={styles.textContainer}>
              <div className={styles.textBlock}>
                <p className={styles.description}>
                  Мы <span className={styles.highlight}>работаем как партнёры</span>, глубоко вникая в задачи каждого клиента для создания эффективных и надёжных ИТ-решений. Для нас главный <span className={styles.highlight}>показатель успеха —<br />это реальная польза,</span> которую наши продукты приносят вашему бизнесу.
                </p>
              </div>
            </div>
            
            {/* <button className={styles.button}>
              <span className={styles.buttonText}>Подробнее о компании</span>
              <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
                <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
              </svg>
            </button> */}
          </div>
          
          {/* Statistics diagram */}
          <div className={styles.statsSection}>
            <AnimatedSection
              animation="growUp"
              delay={50}
              duration={650}
              className={styles.statsBarsGrow}
            >
            {/* Statistics bars */}
            <div className={styles.statsBars}>
              {/* Stat column 1 */}
              <div 
                className={`${styles.statColumn} ${styles.statColumn1}`}
                style={statColumnWidthStyle}
              >
                <div className={styles.statContent}>
                  <div className={styles.statNumber}>
                    <h3 className={styles.statNumberText}>
                      до 80%
                    </h3>
                  </div>
                  <div className={styles.statDescription}>
                    <p className={styles.statDescriptionText}>
                      Сократили потери на производстве клиентов
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Stat column 2 */}
              <div 
                className={`${styles.statColumn} ${styles.statColumn2}`}
                style={statColumnWidthStyle}
              >
                <div className={styles.statContent}>
                  <div className={styles.statNumber}>
                    <h3 className={styles.statNumberText}>
                      х2 раза
                    </h3>
                  </div>
                  <div className={styles.statDescription}>
                    <p className={styles.statDescriptionText}>
                      Увеличили скорость работы сотрудников клиентов
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Stat column 3 */}
              <div 
                className={`${styles.statColumn} ${styles.statColumn3}`}
                style={statColumnWidthStyle}
              >
                <div className={styles.statContent}>
                  <div className={styles.statNumber}>
                    <h3 className={styles.statNumberText}>
                      х3 раза
                    </h3>
                  </div>
                  <div className={styles.statDescription}>
                    <p className={styles.statDescriptionText}>
                      Среднее ускорение бизнес-процессов
                    </p>
                  </div>
                </div>
              </div>
            </div>
            </AnimatedSection>
            
            {/* Subtitle */}
            <div className={styles.statsNote}>
              <div className={styles.noteContainer}>
                <p className={styles.noteText}>
                *Данные на основе выполненных работ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

About.displayName = 'About'

export default About
